import Grid from "@mui/material/Grid";
import breakpoints from "assets/theme/base/breakpoints";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useSelector } from "react-redux";
import SitewideCompareChart from "views/app-views/dashboards/compare/SitewideCompareChart";
import FacebookCompareChart from "views/app-views/dashboards/compare/FacebookCompareChart";
import GoogleCompareChart from "views/app-views/dashboards/compare/GoogleCompareChart";
import NoMerchantWarning from "components/shared-components/NoMerchantWarning";
import WarningMessage from "../warning";
import { useFeatureFlag } from "hooks/useFeatureFlag";

const DashboardContent = () => {
  const { values } = breakpoints;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Grid container>
          <Grid item xs={12}>
            <VuiBox mb={3} p={1}>
              <VuiTypography
                variant={window.innerWidth < values.sm ? "h3" : "h2"}
                textTransform="capitalize"
                fontWeight="bold"
                color="white"
              >
                Compare Dashboard
              </VuiTypography>
            </VuiBox>
          </Grid>
          <Grid item xs={12} mb={3}>
            <SitewideCompareChart />
          </Grid>
          <Grid item xs={12} mb={3}>
            <FacebookCompareChart />
          </Grid>
          <Grid item xs={12} mb={3}>
            <GoogleCompareChart />
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
};

function CompareDashboard() {
  const selectedMer = useSelector((state: any) => state.merchants.selectedMerchant);
  const { isFeatureEnabled } = useFeatureFlag();

  if (!selectedMer?.id) {
    return <NoMerchantWarning />;
  }

  if (!isFeatureEnabled("enabled_compare_dashboard", false)) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Grid container mt={10} justifyContent="center">
          <Grid item xs={12} md={6}>
            <WarningMessage
              text="404"
              detail="There's nothing here"
              url="/app/"
              actionText="Back to Dashboard"
            />
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }

  return <DashboardContent />;
}

export default CompareDashboard; 